import {
    SENDING_APP_FEEDBACK,
    SENDING_APP_FEEDBACK_SUCCESS,
    SENDING_APP_FEEDBACK_FAILURE,
    RESET_SENDING_APP_FEEDBACK,
    SENDING_CONTACT_REQUEST,
    SENDING_CONTACT_REQUEST_SUCCESS,
    SENDING_CONTACT_REQUEST_FAILURE,
    RESET_SENDING_CONTACT_REQUEST,
    SENDING_LINK_REQUEST,
    SENDING_LINK_REQUEST_SUCCESS,
    SENDING_LINK_REQUEST_FAILURE,
    RESET_SENDING_LINK_REQUEST,
    SENDING_LINK_FEEDBACK,
    SENDING_LINK_FEEDBACK_SUCCESS,
    SENDING_LINK_FEEDBACK_FAILURE,
    RESET_SENDING_LINK_FEEDBACK,
} from 'redux/reduxConstants';

export function sendingAppFeedback() {
    return { type: SENDING_APP_FEEDBACK };
}
export function sendingAppFeedbackSuccess() {
    return { type: SENDING_APP_FEEDBACK_SUCCESS };
}
export function sendingAppFeedbackFailure() {
    return { type: SENDING_APP_FEEDBACK_FAILURE };
}
export function resetSendingAppFeedback() {
    return { type: RESET_SENDING_APP_FEEDBACK };
}

export function sendingContactRequest() {
    return { type: SENDING_CONTACT_REQUEST };
}
export function sendingContactRequestSuccess() {
    return { type: SENDING_CONTACT_REQUEST_SUCCESS };
}
export function sendingContactRequestFailure() {
    return { type: SENDING_CONTACT_REQUEST_FAILURE };
}
export function resetSendingContactRequest() {
    return { type: RESET_SENDING_CONTACT_REQUEST };
}

export function sendingLinkRequest() {
    return { type: SENDING_LINK_REQUEST };
}
export function sendingLinkRequestSuccess() {
    return { type: SENDING_LINK_REQUEST_SUCCESS };
}
export function sendingLinkRequestFailure() {
    return { type: SENDING_LINK_REQUEST_FAILURE };
}
export function resetSendingLinkRequest() {
    return { type: RESET_SENDING_LINK_REQUEST };
}

export function sendingLinkFeedback() {
    return { type: SENDING_LINK_FEEDBACK };
}
export function sendingLinkFeedbackSuccess() {
    return { type: SENDING_LINK_FEEDBACK_SUCCESS };
}
export function sendingLinkFeedbackFailure() {
    return { type: SENDING_LINK_FEEDBACK_FAILURE };
}
export function resetSendingLinkFeedback() {
    return { type: RESET_SENDING_LINK_FEEDBACK };
}
